import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import "leaflet/dist/leaflet.css";
// import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { PunchingButton } from '../../components/punchinButton';
import { Button } from '../../components/ui';
import usePut from '../../hooks/put/usePut';
import toast from 'react-hot-toast';
import useGet from '../../hooks/read/useGet';
// import Spinner from '../../components/loader/Spinner';
import L from 'leaflet';
import InlineLoader from '../../components/loader/InlineLoader';
import LocationBlockedCard from '../../components/location/LocationBlockedCard';

// Fix for Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const mapStyles = {
    height: "30vh",
    width: "100%"
};

// Component to recenter map and fix tile alignment when coordinates change
function ChangeView({ center, zoom }) {
    const map = useMap();
    React.useEffect(() => {
        map.setView(center, zoom);
        // This fixes the 'grey area' and miscentering issues on load
        setTimeout(() => {
            map.invalidateSize();
        }, 100);
    }, [center, zoom, map]);
    return null;
}

const PunchIn = () => {
    const location = useLocation()
    console.log(location);

    const [isLocationDenined, setIsLocationDenined] = useState(0)
    const [uploadedImage, setUploadedImage] = useState({})
    const navigate = useNavigate()
    const [isLocationFetched, setIsLocationFetched] = useState(false)
    const [isRequesting, setIsRequesting] = useState(false)
    const [coordinates, setCoordinates] = useState({
        lat: 19.0760,
        lng: 72.8777
    })
    const [zoom, setZoom] = useState(16)

    // Google Maps
    /*
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCYBAbuZ0pN5BkdsJDJ__-3ysfkl5QjdfM" // HRMS KEY
    })
    */

    const { handleAuth } = usePut({
        url: 'punch_in',
        onSuccess: (res) => {
            toast.success(hasPunchedIn ? "Visit marked successfully" : 'Attendance added successfully')
            setTimeout(() => {
                navigate('/')
            }, [2000])
        },
        onError: (err) => {
            const { status, data } = err?.response || {}
            if (status >= 400 || status <= 499) {
                toast.error(data?.message || 'Something went wrong')
            } else {
                toast.error('Internal server error')
            }
        }
    })

    // Google Maps
    /*
    const [map, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(coordinates);
        map.fitBounds(bounds)
        
        setMap(map)
    }, [coordinates])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])
    */

    useEffect(() => {
        // Silently check permission status without prompting
        if (navigator.permissions && navigator.permissions.query) {
            navigator.permissions.query({ name: 'geolocation' }).then((status) => {
                if (status.state === 'granted') {
                    requestLocationAccess();
                } else if (status.state === 'denied') {
                    setIsLocationDenined(1);
                }

                // Automatically fetch or update UI if user changes settings
                status.onchange = () => {
                    if (status.state === 'granted') {
                        requestLocationAccess();
                        setIsLocationDenined(0);
                    } else if (status.state === 'denied') {
                        setIsLocationDenined(1);
                    }
                };
            });
        } else {
            // Fallback for older browsers: We wait for user interaction to prompt
        }
    }, [])

    // Google Maps
    /*
    const markerOnLoad = (marker) => {
        // console.log('marker: ', marker)
    }
    */

    const handleSubmitPunch = () => {
        if (uploadedImage?.image_id) {
            let data = {
                lat: coordinates?.lat,
                long: coordinates?.lng,
                image_id: uploadedImage?.image_id,
                punch_type: hasPunchedIn ? "VISIT" : "PUNCH_IN"
            }
            /*
            let data = {
                lat: coordinates?.lat,
                long: coordinates?.lng,
                image_id: uploadedImage?.image_id,
                punch_type: hasPunchedIn ? "VISIT" : "PUNCH_IN"
            }
            */

            console.log(data);
            handleAuth.mutate(data)
        } else {
            toast.error('Please add picture of yourself')
        }
    }

    const requestLocationAccess = () => {
        setIsRequesting(true)
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { coords } = position
                const data = {
                    lat: coords?.latitude,
                    lng: coords?.longitude
                }
                setZoom(16)
                setCoordinates(data)
                setIsLocationDenined(0)
                setIsLocationFetched(true)
                setIsRequesting(false)
            },
            (error) => {
                if (error.code === error.PERMISSION_DENIED) {
                    setIsLocationDenined(1)
                    toast.error("Location permission denied. Please allow location access in your browser settings.")
                } else if (error.code === error.POSITION_UNAVAILABLE) {
                    toast.error("Location unavailable. Please check your signal.")
                } else if (error.code === error.TIMEOUT) {
                    toast.error("Location request timed out.")
                } else {
                    toast.error("Error requesting location. Please try again.")
                    console.error("Error requesting location:", error);
                }
                setIsRequesting(false)
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
    };

    // Code to check if user has punched in for the day
    const [hasPunchedIn, setHasPunchedIn] = useState(false);

    const { list: getStatusReq } = useGet({
        url: "punch_status",
        onSuccess: (res) => {
            setHasPunchedIn(res?.is_logged_in);
            // setHasPunchedIn(true);
        }
    })

    const { handleAuth: punchOutReq } = usePut({
        url: "punch_out",
        onSuccess: (res) => {
            toast.success('Punched out successfully');
            setTimeout(() => {
                navigate('/')
            }, [2000])
        },
        onError: (err) => {
            const { status, data } = err?.response || {}
            if (status >= 400 || status <= 499) {
                toast.error(data?.message || 'Something went wrong')
            } else {
                toast.error('Internal server error')
            }
        }
    });

    const handlePunchOut = () => {
        if (uploadedImage?.image_id) {
            let data = {
                lat: coordinates?.lat,
                long: coordinates?.lng,
                image_id: uploadedImage?.image_id,
            }

            // Google Maps
            /*
            let data = {
                lat: coordinates?.lat,
                long: coordinates?.lng,
                image_id: uploadedImage?.image_id,
            }
            */

            // console.log(data);
            punchOutReq.mutate(data)
        } else {
            toast.error('Please add picture of yourself')
        }
    }

    return (
        <div className='px-5 '>
            {/* <div className='flex items-center justify-end'>
                <Link to={`/attendance-punch-in/logs`} className=' text-blue-600 font-semibold hover:underline'>
                    View Punch Logs
                </Link>
            </div> */}
            <div className='my-4 flex flex-col  justify-between min-h-[calc(100vh_-_8rem)]'>
                <div>
                    <div>
                        {isLocationDenined ? (
                            <LocationBlockedCard />
                        ) : (
                            <div style={mapStyles}>
                                {/* OpenStreetMap */}
                                <MapContainer
                                    center={[coordinates.lat, coordinates.lng]}
                                    zoom={zoom}
                                    style={{ height: "100%", width: "100%" }}
                                >
                                    <ChangeView center={[coordinates.lat, coordinates.lng]} zoom={zoom} />
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <Marker position={[coordinates.lat, coordinates.lng]} />
                                </MapContainer>

                                {/* Google Maps */}
                                {/*
                            {isLoaded ? (
                                <GoogleMap
                                    mapContainerStyle={mapStyles}
                                    center={coordinates}
                                    zoom={zoom}
                                    onLoad={onLoad}
                                    onUnmount={onUnmount}
                                >
                                    <Marker visible={true} position={coordinates} onLoad={markerOnLoad} />
                                </GoogleMap>
                            ) : <></>}
                            */}
                            </div>
                        )}
                        <PunchingButton setUploadedImage={setUploadedImage} />
                    </div>
                </div>
                <div className='flex items-center justify-center'>
                    {getStatusReq.isLoading ? (
                        <p>Loading...</p>
                    ) : (
                        <>
                            {!isLocationDenined ? (
                                (hasPunchedIn || location?.pathname === "/punchout") ? (
                                    <div className='flex items-center space-x-7'>
                                        {location?.pathname === "/punchout" ? (
                                            <Button disabled={isRequesting} onClick={isLocationFetched ? handlePunchOut : requestLocationAccess}>
                                                {isRequesting ? (
                                                    <div className='flex items-center gap-2'><InlineLoader /> <span className='text-xs'>Fetching Location...</span></div>
                                                ) : isLocationFetched ? (
                                                    "Punch out"
                                                ) : (
                                                    "Get Location"
                                                )}
                                            </Button>
                                        ) : (
                                            <Button disabled={isRequesting} variant="outline" onClick={isLocationFetched ? handleSubmitPunch : requestLocationAccess}>
                                                {isRequesting ? (
                                                    <div className='flex items-center gap-2'><InlineLoader className="!text-black" /> <span className='text-xs'>Fetching Location...</span></div>
                                                ) : isLocationFetched ? (
                                                    "Mark visit"
                                                ) : (
                                                    "Get Location"
                                                )}
                                            </Button>
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        <Button disabled={isLocationDenined || isRequesting} onClick={isLocationFetched ? handleSubmitPunch : requestLocationAccess}>
                                            {isRequesting ? (
                                                <div className='flex items-center gap-2'><InlineLoader /> <span className='text-xs'>Fetching Location...</span></div>
                                            ) : isLocationFetched ? (
                                                "Punch in"
                                            ) : (
                                                "Get Location"
                                            )}
                                        </Button>
                                    </div>
                                )
                            ) : (
                                <Button onClick={requestLocationAccess}>
                                    Grant Location Access
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export { PunchIn }